/* stylelint-disable no-descending-specificity */

%sticky {
  position: sticky !important;
  z-index: var(--z-index-tab-template-component);
}

.wrap {
  --margin-inline-expanded-row-table: 40px -8px;
  --margin-expanded-row-table: 40px 0 40px 32px;
  --selected-bg-color: var(--neutral-2-color);
  --display-ant-spin-dot-spin-table: sticky;
  --z-index-cell-resizable-table-tab-template-component: 7;
  --z-index-tab-template-component: 5;
  --z-index-th-scroll-y-tab-template-component: calc(
    var(--z-index-tab-template-component) + 1
  );
  --z-index-filter-tab-template-component: calc(
    var(--z-index-tab-template-component) + 6
  );
  --background-color-td-sticky-resizable: var(--neutral-1-color);
  --bg-hover-row-level-0-expanded-row: var(--selected-bg-color);
  --cursor-row-level-0-expanded-row: "pointer";
  --value-height-spin-spinning: var(--height-spin-spinning-tab-template);
  --multiplier-footer-tab-template: 1.75;

  &:has(div:nth-child(2) > div > div > :global(.ant-spin-blur)) {
    display: initial;
  }

  th,
  thead > tr > td {
    // thead > tr > td - for antd table because when no set title there is td instead th in thead
    @extend %sticky;

    top: 68px;
  }

  &:has(> div > div > div[data-filter-type="2"]) {
    th,
    thead > tr > td {
      top: 108px;
    }
  }

  :global {
    .ant-input-group-wrapper {
      width: 250px;
    }

    .ant-table-thead > tr > th {
      position: sticky;
      font-weight: 500;
      height: var(--height-td-table-tab-template);
    }

    .ant-table-tbody > tr > td {
      height: var(--height-td-table-tab-template);
    }

    .ant-table-tbody > tr > td,
    .ant-table-thead > tr > th {
      padding: var(--padding-cell-table-tab-template);
    }

    .ant-table-tbody td.ant-table-selection-column {
      padding: 0 !important;

      > label {
        padding: 5px;
      }
    }

    .capitalize-tab-template-component {
      text-transform: capitalize;
    }

    .center-align-tab-template-component {
      text-align: center;
    }

    .ant-table-tbody {
      .ant-empty {
        visibility: hidden;
      }
    }

    .ant-spin-nested-loading {
      min-height: var(--value-height-spin-spinning);
    }

    .ant-spin-spinning:not(.ant-spin-default-style) {
      max-width: calc(
        var(--outlet-layout-width) - var(--outlet-layout-padding-tab-template)
      ) !important;
      position: var(--value-position-spin-spinning, relative) !important;
      height: var(--value-height-spin-spinning) !important;
      min-height: var(--value-height-spin-spinning) !important;
      display: var(
        --display-ant-spin-spinning-table-tab-template,
        flex
      ) !important;
      align-items: flex-start;
      justify-content: center;
      z-index: calc(var(--z-index-tab-template-component) + 1);

      > span {
        position: var(--display-ant-spin-dot-spin-table) !important;
      }
    }

    .ant-table-expanded-row-level-1 > td.ant-table-cell {
      padding: 0 var(--padding-cell-table-tab-template);
      background-color: var(--neutral-1-color);

      .ant-table-tbody > tr:last-child > td {
        border-bottom: none;
      }
    }

    [data-opened-in-drawer="true"] {
      > td {
        background-color: var(--selected-bg-color);
      }

      > td:first-child {
        box-shadow: inset 3px 0 0 0 var(--daybreak-blue-5-color);
      }
    }
  }

  &.collecting-data {
    overflow: hidden;
  }

  &.sticky-wrap {
    --multiplier-footer-tab-template: 1;
  }
}

.filters {
  @extend %sticky;

  z-index: var(--z-index-filter-tab-template-component);
  top: 0;
  padding: 16px 0;
  background-color: var(--neutral-1-color);
}

.tab-position-left {
  top: var(--height-header);
}

.footer {
  --bottom-footer-tab-template: calc(
    0px +
      calc(
        var(--padding-layout-template) * var(--multiplier-footer-tab-template)
      )
  );

  position: sticky;
  height: 56px;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: var(--neutral-1-color);
  bottom: 0;
  z-index: calc(var(--z-index-cell-resizable-table-tab-template-component) + 1);

  %block {
    padding: 16px 16px 16px 0;
    position: fixed;
    bottom: var(--bottom-footer-tab-template);
  }

  .aside {
    @extend %block;

    &:has(:global(.selected-all-available-issue-actions-ks)) {
      padding: 0 16px 4px;
    }
  }

  .pagination {
    @extend %block;

    right: calc(
      0px + var(--width-ai-chat) + var(--margin-ai-chat) +
        var(--padding-layout-template) + var(--padding-layout-template)
    );
  }
}

.footer_none {
  display: none;
}

.footer-kai {
  --bottom-div-footer-tab-template-tabs-drawer-template: 16px;

  bottom: var(--bottom-footer-kai-tab-template, 16px);
}

.loading {
  div[data-component-id="col-table-tab-template-component-ks"] {
    tbody > tr {
      display: none;
    }
  }
}

.empty {
  --height-empty-tab-template: calc(100vh - 380px);

  &.empty-auto {
    --height-empty-tab-template: auto;
  }

  :global {
    .ant-table-tbody {
      .ant-empty {
        visibility: visible;
        height: var(--height-empty-tab-template);
      }
    }
  }
}

.row {
  cursor: pointer;
}

tr.disabled-row {
  cursor: default;

  :global(.ant-table-cell) {
    color: var(--neutral-6-color);
  }
}

.without-search-component {
  padding: var(--padding-layout-without-search-component, 16px 0 0);

  th,
  thead > tr > td {
    @extend %sticky;

    top: unset;
  }
}

.with-expandable-component {
  :global {
    .ant-table-row-level-0 {
      cursor: pointer;
    }

    .ant-table-row-level-0:has(
      + tr.ant-table-expanded-row-level-1:not([style*="display: none"])
    ) {
      background: var(--selected-bg-color);
    }

    td:has(+ th[aria-sort]:not([aria-sort=""])),
    td:has(+ th:hover) {
      background: var(--neutral-4-color);
    }

    .ant-table-expanded-row-level-1 {
      > .ant-table-cell {
        padding: 0 !important;

        &:hover {
          background: var(--neutral-1-color);
        }
      }

      .ant-table-row-level-0:not(.ant-table-row-selected)
        > .ant-table-cell-row-hover {
        cursor: var(--cursor-row-level-0-expanded-row, default);
        background: var(--bg-hover-row-level-0-expanded-row, unset);

        &:hover {
          background: var(--bg-hover-row-level-0-expanded-row, unset);
        }
      }

      .ant-spin-nested-loading {
        min-height: initial;
      }
    }
  }
}

.no-data {
  :global(.ant-table-placeholder > .ant-table-cell) {
    border-bottom: none;
  }
}

.header-component {
  padding-top: 16px;
}

.resizable-or-sticky {
  --default-width-resizable-or-sticky: 100%;

  :global {
    .ant-table-content > table {
      width: var(
        --outlet-layout-width-open-chat,
        var(--default-width-resizable-or-sticky)
      );
    }

    .ant-table-expanded-row-level-1 {
      .ant-table-content > table {
        width: var(--default-width-resizable-or-sticky);
      }
    }
  }
}

.table-component {
  padding: var(--padding-layout-table-component, 0);
}
